export default __webpack_public_path__ + "static/media/icons-menu-entities.00e4bad0.svg";